import _ from "lodash";
import moment from "moment";
import React from "react";
import {
  SectionOutlined,
  AttendanceOutlined,
  CalendarScheduleWeekOutlined,
  CalendarClockOutlined,
  GridOutlined,
  TableOutlined,
  SettingsOutlined,
  ClassProgressOutlined,
  PinOutlined,
  PencilLineOutlined,
  DeleteOutlined,
  ShareCurveOutlined,
  CopyOutlined,
  DotsHorizontalOutlined,
  JournalOutlined,
  CalculatorOutlined,
  SinglePointRubricOutlined,
  PercentageOutlined,
  AddOutlined,
  UpDownArrowOutlined,
} from "@toddle-edu/ds-icons";
import { colors } from "@toddle-edu/ds-theme";
import ACLStore from "lib/aclStore";

import {
  ATTENDANCE_CONSTANTS,
  TIMETABLE_CONSTANTS,
} from "Constants/attendanceConstants";
import { getSettingValue } from "modules/PermissionModule";
import { ATTENDANCE_GLOBAL_CONSTANTS } from "modules/Services/ServicesConstants";
import {
  checkIsToddleV2AttendanceEnabled,
  checkSMSSendVisible,
} from "AttendanceDashboard/modules/Utils";

export const COLUMNS = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

const iconStyles = {
  color: "var(--icon-secondary)",
};

export const getSideNavigationOptions = ({ t, isAccountLevel }) => {
  const divider = {
    key: "DIVIDER",
    isDivider: true,
    isVisible: true,
  };

  return [
    {
      key: "root",
      children: checkIsToddleV2AttendanceEnabled()
        ? ["ATTENDANCE", "TIMETABLE"]
        : ["TIMETABLE"],
    },

    // attendance
    {
      children: [
        // "ATTENDANCE_SETUP_ASSISTANT",
        "ATTENDANCE_CATEGORIES",
        "CODES",
        ...(isAccountLevel
          ? [
              "ATTENDANCE_TIER_SETS",
              "ATTENDANCE_SCHOOLWISE_CONFIGURATION",
              "ATTENDANCE_PERMISSIONS",
            ]
          : [
              "ATTENDANCE_TIERS",
              "ATTENDANCE_RECORDING",
              "ATTENDANCE_CALCULATION",
            ]),
        "DIVIDER",
      ],
      key: "ATTENDANCE",
      title: t("attendance:attendance"),
      parent: "root",
      tier: 2,
    },
    // {
    //   children: [],
    //   key: "ATTENDANCE_SETUP_ASSISTANT",
    //   parent: "ATTENDANCE",
    //   tier: 1,
    //   title: "Setup assistant",
    //   prefix: <SetupOutlined />,
    // },
    {
      children: [],
      key: "ATTENDANCE_CATEGORIES",
      parent: "ATTENDANCE",
      tier: 1,
      title: t("common:category_plural"),
      prefix: <SectionOutlined />,
    },
    {
      children: [],
      key: "CODES",
      parent: "ATTENDANCE",
      tier: 1,
      title: t("common:code_plural"),
      prefix: <AttendanceOutlined />,
    },
    ...(isAccountLevel
      ? [
          {
            children: [],
            key: "ATTENDANCE_TIER_SETS",
            parent: "ATTENDANCE",
            tier: 1,
            title: t("attendance:tier_set_plural"),
            prefix: <PercentageOutlined />,
          },
        ]
      : [
          [
            {
              children: [],
              key: "ATTENDANCE_TIERS",
              parent: "ATTENDANCE",
              tier: 1,
              title: t("attendance:tier_plural"),
              prefix: <PercentageOutlined />,
            },
          ],
        ]),
    ...(isAccountLevel
      ? []
      : [
          {
            children: [],
            key: "ATTENDANCE_RECORDING",
            parent: "ATTENDANCE",
            tier: 1,
            title: t("common:recording"),
            prefix: <JournalOutlined />,
          },
        ]),
    ...(isAccountLevel
      ? []
      : [
          {
            children: [],
            key: "ATTENDANCE_CALCULATION",
            parent: "ATTENDANCE",
            tier: 1,
            title: t("common:calculation"),
            prefix: <CalculatorOutlined />,
          },
        ]),
    ...(isAccountLevel
      ? [
          {
            children: [],
            key: "ATTENDANCE_SCHOOLWISE_CONFIGURATION",
            parent: "ATTENDANCE",
            tier: 1,
            title: t("attendance:school_wise_configuration"),
            prefix: <TableOutlined />,
          },
        ]
      : []),
    ...(isAccountLevel
      ? [
          {
            children: [],
            key: "ATTENDANCE_PERMISSIONS",
            parent: "ATTENDANCE",
            tier: 1,
            title: t("attendance:attendance_permissions"),
            prefix: <GridOutlined />,
          },
        ]
      : []),
    divider,

    // timetable
    {
      children: [
        // "TIMETABLE_SETUP_ASSISTANT",
        "DAY_CYCLES",
        "PERIODS",
        "BELL_SCHEDULES",
        "TIMETABLE_TEMPLATES",
        ...(isAccountLevel ? ["SCHOOLWISE_INFORMATION"] : []),
        ...(isAccountLevel ? ["TIMETABLE_PERMISSIONS"] : []),
        ...(!isAccountLevel ? ["LOCATIONS"] : []),
        ...(!isAccountLevel ? ["YARD_DUTIES"] : []),
      ],
      key: "TIMETABLE",
      title: t("common:timetable"),
      parent: "root",
      tier: 2,
    },
    // {
    //   children: [],
    //   key: "TIMETABLE_SETUP_ASSISTANT",
    //   parent: "TIMETABLE",
    //   tier: 1,
    //   title: "Setup assistant",
    //   prefix: <SetupOutlined />,
    // },
    {
      children: [],
      key: "DAY_CYCLES",
      parent: "TIMETABLE",
      tier: 1,
      title: t("attendance:day_cycles"),
      prefix: <CalendarScheduleWeekOutlined />,
    },
    {
      children: [],
      key: "PERIODS",
      parent: "TIMETABLE",
      tier: 1,
      title: t("common:period_plural"),
      prefix: <SinglePointRubricOutlined />,
    },
    {
      children: [],
      key: "BELL_SCHEDULES",
      parent: "TIMETABLE",
      tier: 1,
      title: t("attendance:bell_schedules"),
      prefix: <CalendarClockOutlined />,
    },
    {
      children: [],
      key: "TIMETABLE_TEMPLATES",
      parent: "TIMETABLE",
      tier: 1,
      title: t("attendance:timetable_templates"),
      prefix: <GridOutlined />,
    },
    ...(isAccountLevel
      ? [
          {
            children: [],
            key: "SCHOOLWISE_INFORMATION",
            parent: "TIMETABLE",
            tier: 1,
            title: t("attendance:school_wise_information"),
            prefix: <TableOutlined />,
          },
        ]
      : []),
    ...(isAccountLevel
      ? [
          {
            children: [],
            key: "TIMETABLE_PERMISSIONS",
            parent: "TIMETABLE",
            tier: 1,
            title: t("attendance:timetable_permissions"),
            prefix: <SettingsOutlined />,
          },
        ]
      : []),
    ...(!isAccountLevel
      ? [
          {
            children: [],
            key: "LOCATIONS",
            parent: "TIMETABLE",
            tier: 1,
            title: t("common:location_plural"),
            prefix: <PinOutlined />,
          },
        ]
      : []),
    ...(!isAccountLevel
      ? [
          {
            children: [],
            key: "YARD_DUTIES",
            parent: "TIMETABLE",
            tier: 1,
            title: t("attendance:yard_duties"),
            prefix: <ClassProgressOutlined />,
          },
        ]
      : []),

    divider,
  ];
};

export const optionsWithIcon = ({
  t,
  handleApplyToSchool,
  isAccountLevel,
  entityType,
  handleEditClick,
  handleDuplicateClick,
  handleDeleteClick,
  handleChangeOrderClick,
  isDuplicateDisabled = false,
  isDeleteDisabled = false,
  deletedDisabledTooltip = "",
}) => {
  return [
    {
      key: "ACTION",
      label: t("common:edit"),
      icon: <PencilLineOutlined size="xx-small" />,
      clickAction: handleEditClick,
    },
    ...(entityType === "CODES" && getIsAttendanceCodesSortingEnabled()
      ? [
          {
            key: "CHANGE_ORDER",
            label: t("common:change_order"),
            icon: <UpDownArrowOutlined size="xx-small" />,
            clickAction: handleChangeOrderClick,
          },
        ]
      : []),
    ...(isAccountLevel && entityType !== "CATEGORIES"
      ? [
          {
            key: "APPLY_TO_SCHOOLS",
            label: t("attendance:apply_to_schools"),
            icon: <ShareCurveOutlined size="xx-small" />,
            clickAction: handleApplyToSchool,
          },
        ]
      : []),
    // Only include DUPLICATE option for bell schedules
    ...(entityType === TIMETABLE_CONSTANTS.BELL_SCHEDULES
      ? [
          {
            key: "DUPLICATE",
            label: t("common:duplicate"),
            icon: <CopyOutlined size="xx-small" />,
            clickAction: handleDuplicateClick,
            disabled: isDuplicateDisabled,
          },
        ]
      : []),
    {
      key: "DELETE",
      isDestructive: true,
      label: t("common:delete"),
      icon: <DeleteOutlined size="xx-small" />,
      clickAction: handleDeleteClick,
      disabled: isDeleteDisabled,
      disabledTooltip: deletedDisabledTooltip,
    },
  ];
};

export const getMultiActionsWithIcon = ({
  defaultDropdownOptions,
  tooltip,
  additionalActions = [],
  disabled = false,
  canManage = true,
}) => {
  const actionItems = [];

  if (!_.isEmpty(defaultDropdownOptions)) {
    actionItems.push({
      isActionGroup: true,
      hasDropdown: true,
      options: defaultDropdownOptions,
      icon: <DotsHorizontalOutlined style={iconStyles} />,
      tooltip,
      disabled,
      canManage,
    });
  }

  const additionalActionItems = _.map(additionalActions, action => ({
    isActionGroup: true,
    hasDropdown: !!_.get(action, "options"),
    options: _.get(action, "options"),
    icon: _.get(action, "icon"),
    clickAction: _.get(action, "clickAction"),
    disabled: _.defaultTo(_.get(action, "disabled"), false),
    tooltip: _.get(action, "tooltip"),
    canManage: _.get(action, "canManage", true),
    buttonTestId: _.get(action, "testId"),
  }));

  return [...actionItems, ...additionalActionItems];
};

export const getConfigureColumnsConfig = ({ isHomeroomClassEnabled }) => {
  return {
    defaultSetupTableColumns: {
      PERIODS: [
        TIMETABLE_CONSTANTS.ABBREVIATION,
        TIMETABLE_CONSTANTS.TYPE,
        TIMETABLE_CONSTANTS.USED_IN_BELL_SCHEDULES,
        TIMETABLE_CONSTANTS.APPLIED_TO_SCHOOLS,
      ],
      BELL_SCHEDULES: [
        TIMETABLE_CONSTANTS.NO_OF_PERIODS,
        TIMETABLE_CONSTANTS.USED_IN_TEMPLATES,
        TIMETABLE_CONSTANTS.APPLIED_TO_SCHOOLS,
      ],
      DAY_CYCLES: [
        DAY_CYCLE_TABLE_CONSTANTS.NO_OF_DAYS,
        DAY_CYCLE_TABLE_CONSTANTS.USED_IN_TEMPLATES,
        DAY_CYCLE_TABLE_CONSTANTS.APPLIED_TO_SCHOOLS,
      ],
      TIMETABLE_TEMPLATES: [
        "DAY_CYCLE",
        "BELL_SCHEDULES_USED",
        DAY_CYCLE_TABLE_CONSTANTS.APPLIED_TO_SCHOOLS,
      ],
      SCHOOLWISE_INFO: [
        TIMETABLE_CONSTANTS.TIMETABLE_TEMPLATES,
        TIMETABLE_CONSTANTS.DAY_CYCLES,
        TIMETABLE_CONSTANTS.PERIODS,
        TIMETABLE_CONSTANTS.BELL_SCHEDULES,
      ],
      ATTENDANCE_SCHOOLWISE_CONFIG: [
        ATTENDANCE_CONSTANTS.ATTENDANCE_CODE,
        ATTENDANCE_GLOBAL_CONSTANTS.ATTENDANCE_RECORDING_TYPE,
        isHomeroomClassEnabled
          ? ATTENDANCE_CONSTANTS.DAILY_ATTENDANCE_RECORDED_IN
          : ATTENDANCE_CONSTANTS.LINK_PERIOD,
        ATTENDANCE_GLOBAL_CONSTANTS.ATTENDANCE_RECORDING_FROM_DATE,
      ],
      TIMETABLES: [
        TIMETABLE_CONSTANTS.VALIDITY_PERIOD,
        TIMETABLE_CONSTANTS.APPLICABLE,
        TIMETABLE_CONSTANTS.STATUS,
      ],
      CATEGORIES: [
        "DESCRIPTION",
        "COLOR",
        "ASSOCIATED_WITH_CODES",
        "APPLIED_TO_SCHOOLS",
        "CREATED_BY",
      ],
      CODES: [
        "CATEGORY",
        "ABBREVIATION",
        "PRESENT_IN_CAMPUS",
        "ATTENDANCE_TYPE",
        "VALUE",
        "APPLIED_TO_SCHOOLS",
      ],
      TIER_SETS: [
        ATTENDANCE_CONSTANTS.DESCRIPTION,
        ATTENDANCE_CONSTANTS.TIERS,
        TIMETABLE_CONSTANTS.APPLIED_TO_SCHOOLS,
      ],
      IMPORT_LOG: [
        "IMPORTED_ON",
        "IMPORTED_BY",
        "IMPORTED_METHOD",
        "IMPORTED_IN_TIMETABLE",
        "IMPORTED_DURATION",
      ],
    },
    tableToSettingsMap: {
      PERIODS: "AttendancePeriodsTableColumns",
      BELL_SCHEDULES: "AttendanceBellSchedulesTableColumns",
      DAY_CYCLES: "AttendanceDayCyclesTableColumns",
      TIMETABLE_TEMPLATES: "AttendanceTimetableTemplatesTableColumns",
      SCHOOLWISE_INFO: "TimetableSchoolWiseConfigTableColumns",
      ATTENDANCE_SCHOOLWISE_CONFIG: "AttendanceSchoolWiseConfigTableColumns",
      TIMETABLES: "AttendanceTimetableTableColumns",
      CATEGORIES: "AttendanceCategoriesTableColumns",
      CODES: "AttendanceCodesTableColumns",
      TIER_SETS: "AttendanceTierSetsTableColumns",
      IMPORT_LOG: "TimetableImportLogTableColumns",
    },
  };
};

export const getConfiguredColumns = ({
  type,
  userId,
  curriculumProgramId,
  isAccountLevel,
  isHomeroomClassEnabled,
}) => {
  const {
    defaultSetupTableColumns,
    tableToSettingsMap,
  } = getConfigureColumnsConfig({ isHomeroomClassEnabled });

  const settingName = _.get(tableToSettingsMap, [type]);

  const settingsObj = getSettingValue({
    userId,
    name: settingName,
    currentCurriculumProgramId: curriculumProgramId,
    isAccountLevel,
  });

  // If the settingsObj is empty or null, use the default setup table columns
  let configuredColumns = _.get(
    settingsObj,
    [curriculumProgramId],
    defaultSetupTableColumns[type]
  );

  // Add SORT_ORDER to CODES columns if feature flag is enabled and it's not already there
  if (type === "CODES" && getIsAttendanceCodesSortingEnabled()) {
    if (!_.includes(configuredColumns, "SORT_ORDER")) {
      configuredColumns = [...configuredColumns, "SORT_ORDER"];
    }
  }

  return { settingsObj, configuredColumns };
};

export const getFinalColumnList = ({
  columnList,
  excludedColumnIds = [],
  configuredColumns,
  showConfigurableColumns,
  requiredColumns,
}) => {
  // filtered configureable columns
  const configurableColumns = _.filter(columnList, ({ id }) => {
    return !_.includes(excludedColumnIds, id);
  });

  // Ordering the columns based on the order the user selected - required for both the table and the configuring modal
  const orderedColumns = _.reduce(
    configuredColumns,
    (result, id) => {
      const column = _.head(_.remove(configurableColumns, { id }));
      if (column) result.push(column);
      return result;
    },
    []
  );

  // appending the unselected columns to the end of the list
  if (showConfigurableColumns) orderedColumns.push(...configurableColumns);
  else requiredColumns.splice(1, 0, ...orderedColumns); // Adding essential columns by default for the table

  return _.map(showConfigurableColumns ? orderedColumns : requiredColumns);
};

const periodStyles = {
  nameColumnStyle: {
    maxWidth: "600px",
    minWidth: "248px",
  },
  standardColumnStyle: {
    width: "200px",
  },
  actionColumnStyle: {
    width: "36px",
  },
};

export const getPeriodsColumnList = ({
  configuredColumns,
  showConfigurableColumns,
  isAccountLevel,
  t,
}) => {
  const requiredColumns = [
    {
      id: TIMETABLE_CONSTANTS.PERIOD_NAME,
      label: t("common:period_name"),
      style: periodStyles.nameColumnStyle,
      type: "TEXT_COLUMN",
      sortType: "toggle",
      hasSortingEnabled: true,
      isSticky: true,
    },
    {
      id: TIMETABLE_CONSTANTS.ACTIONS,
      style: periodStyles.actionColumnStyle,
      type: "ACTIONS",
    },
  ];

  const periodColumns = [
    {
      id: TIMETABLE_CONSTANTS.ABBREVIATION,
      label: t("common:abbreviation"),
      style: periodStyles.standardColumnStyle,
      type: "TEXT_COLUMN",
    },
    {
      id: TIMETABLE_CONSTANTS.TYPE,
      label: t("common:type"),
      style: periodStyles.standardColumnStyle,
      type: "TEXT_COLUMN",
    },
    {
      id: TIMETABLE_CONSTANTS.USED_IN_BELL_SCHEDULES,
      label: t("attendance:used_in_label", {
        label: t("attendance:bell_schedules"),
      }),
      style: periodStyles.standardColumnStyle,
      type: "POPOVER_COLUMN",
      alignment: "center",
    },
    ...(isAccountLevel
      ? [
          {
            id: TIMETABLE_CONSTANTS.APPLIED_TO_SCHOOLS,
            label: t("attendance:applied_to_schools"),
            style: periodStyles.standardColumnStyle,
            type: "POPOVER_COLUMN",
            alignment: "center",
          },
        ]
      : []),
    {
      id: TIMETABLE_CONSTANTS.PERIOD_ID,
      label: t("attendance:period_id"),
      style: periodStyles.standardColumnStyle,
      type: "TEXT_COLUMN",
      alignment: "center",
    },
    {
      id: TIMETABLE_CONSTANTS.USED_IN_TEMPLATE,
      label: t("attendance:used_in_label", {
        label: t("common:template"),
      }),
      style: periodStyles.standardColumnStyle,
      type: "POPOVER_COLUMN",
      alignment: "center",
    },
    {
      id: TIMETABLE_CONSTANTS.CREATED_BY,
      label: t("common:created_by"),
      style: periodStyles.standardColumnStyle,
      type: "TEXT_COLUMN",
      alignment: "center",
    },
  ];

  return getFinalColumnList({
    columnList: periodColumns,
    configuredColumns,
    showConfigurableColumns,
    requiredColumns,
  });
};

export const getPeriodsColumnListMemoised = _.memoize(
  params => getPeriodsColumnList(params),
  params => JSON.stringify(params)
);

export const getCategoriesColumnList = ({
  configuredColumns,
  showConfigurableColumns,
  isAccountLevel,
  t,
}) => {
  const requiredColumns = [
    {
      id: "CATEGORY_NAME",
      label: t("attendance:category_name"),
      style: periodStyles.nameColumnStyle,
      type: "TEXT_COLUMN",
      sortType: "toggle",
      hasSortingEnabled: true,
      isSticky: true,
    },
    ...(isAccountLevel
      ? [
          {
            id: "ACTIONS",
            style: periodStyles.actionColumnStyle,
            type: "ACTIONS",
            alignment: "center",
          },
        ]
      : []),
  ];

  const categoryColumns = [
    {
      id: "DESCRIPTION",
      label: t("common:description"),
      type: "TEXT_COLUMN",
    },
    {
      id: "COLOR",
      label: t("common:color"),
      type: "CUSTOM",
      alignment: "center",
      style: {
        width: "56px",
      },
    },
    {
      id: "ASSOCIATED_WITH_CODES",
      label: t("attendance:associated_with_label", {
        label: t("common:code_plural"),
      }),
      style: {
        width: "156px",
      },
      type: "POPOVER_COLUMN",
      alignment: "center",
    },
    ...(isAccountLevel
      ? [
          {
            id: TIMETABLE_CONSTANTS.APPLIED_TO_SCHOOLS,
            label: t("attendance:applied_to_schools"),
            style: {
              width: "156px",
            },
            type: "POPOVER_COLUMN",
            alignment: "center",
          },
        ]
      : []),
    {
      id: TIMETABLE_CONSTANTS.CREATED_BY,
      label: t("common:created_by"),
      style: periodStyles.standardColumnStyle,
      type: "TEXT_COLUMN",
      alignment: "center",
    },
  ];

  return getFinalColumnList({
    columnList: categoryColumns,
    configuredColumns,
    showConfigurableColumns,
    requiredColumns,
  });
};

export const getCategoriesColumnListMemoised = _.memoize(
  params => getCategoriesColumnList(params),
  params =>
    JSON.stringify({
      configuredColumns: params.configuredColumns,
      showConfigurableColumns: params.showConfigurableColumns,
      isAccountLevel: params.isAccountLevel,
    })
);

export const getTierSetsColumnList = ({
  configuredColumns,
  showConfigurableColumns,
  t,
}) => {
  const requiredColumns = [
    {
      id: ATTENDANCE_CONSTANTS.TIER_SET_NAME,
      label: t("common:name"),
      style: periodStyles.nameColumnStyle,
      type: "TEXT_COLUMN",
      isSticky: true,
    },
    {
      id: TIMETABLE_CONSTANTS.ACTIONS,
      style: periodStyles.actionColumnStyle,
      type: "ACTIONS",
      alignment: "center",
    },
  ];

  const tierSetColumns = [
    {
      id: ATTENDANCE_CONSTANTS.DESCRIPTION,
      label: t("common:description"),
      type: "TEXT_COLUMN",
    },
    {
      id: ATTENDANCE_CONSTANTS.TIERS,
      label: t("attendance:tier_plural"),
      style: {
        width: "156px",
      },
      type: "POPOVER_COLUMN",
      alignment: "center",
    },
    {
      id: TIMETABLE_CONSTANTS.APPLIED_TO_SCHOOLS,
      label: t("attendance:applied_to_schools"),
      style: {
        width: "156px",
      },
      type: "POPOVER_COLUMN",
      alignment: "center",
    },
    {
      id: ATTENDANCE_CONSTANTS.CREATED_BY,
      label: t("common:created_by"),
      style: periodStyles.standardColumnStyle,
      type: "AVATAR_WITH_TEXT",
      alignment: "center",
    },
    {
      id: ATTENDANCE_CONSTANTS.LAST_UPDATED_BY,
      label: t("common:last_updated_by"),
      style: periodStyles.standardColumnStyle,
      type: "AVATAR_WITH_TEXT",
      alignment: "center",
    },
    {
      id: ATTENDANCE_CONSTANTS.LAST_UPDATE_AT,
      label: "Last update at",
      style: periodStyles.standardColumnStyle,
      type: "TEXT_COLUMN",
      alignment: "center",
    },
    {
      id: ATTENDANCE_CONSTANTS.TIER_SET_ID,
      label: t("common:id"),
      style: periodStyles.standardColumnStyle,
      type: "TEXT_COLUMN",
      alignment: "center",
    },
  ];

  return getFinalColumnList({
    columnList: tierSetColumns,
    configuredColumns,
    showConfigurableColumns,
    requiredColumns,
  });
};

export const getTierSetsColumnListMemoised = _.memoize(
  params => getTierSetsColumnList(params),
  params => JSON.stringify(params)
);

export const getCodesColumnListMemoised = _.memoize(
  params => getCodesColumnList(params),
  params =>
    JSON.stringify({
      configuredColumns: params.configuredColumns,
      showConfigurableColumns: params.showConfigurableColumns,
      isAccountLevel: params.isAccountLevel,
    })
);

export const getCodesColumnList = ({
  configuredColumns,
  showConfigurableColumns,
  isAccountLevel,
  t,
}) => {
  const requiredColumns = [
    {
      id: "CODE_NAME",
      label: t("common:label_name", {
        label: t("common:code"),
      }),
      style: periodStyles.nameColumnStyle,
      type: "TEXT_COLUMN",
      sortType: "toggle",
      hasSortingEnabled: true,
      isSticky: true,
    },
    {
      id: "ACTIONS",
      style: periodStyles.actionColumnStyle,
      type: "ACTIONS",
      alignment: "center",
    },
  ];

  const codeColumns = [
    {
      id: "CATEGORY",
      label: t("common:category"),
      type: "TEXT_COLUMN",
      style: {
        width: "156px",
      },
    },
    {
      id: "ABBREVIATION",
      label: t("common:abbreviation"),
      type: "TEXT_COLUMN",
      alignment: "center",
      style: {
        width: "156px",
      },
    },
    ...(!checkIsAttendanceCodeEnhancementEnabled()
      ? [
          {
            id: "PRESENT_IN_CAMPUS",
            label: t("attendance:present_in_campus"),
            style: {
              width: "156px",
            },
            type: "TEXT_COLUMN",
            alignment: "center",
          },
        ]
      : []),
    ...(checkIsAttendanceCodeEnhancementEnabled()
      ? [
          {
            id: "IS_EXCUSED",
            label: t("attendance:is_excused"),
            style: {
              width: "156px",
            },
            type: "TEXT_COLUMN",
            alignment: "center",
          },
        ]
      : []),
    ...(checkIsAttendanceCodeEnhancementEnabled()
      ? [
          {
            id: "ATTENDANCE_TYPE",
            label: t("common:type"),
            style: {
              width: "156px",
            },
            type: "TEXT_COLUMN",
            alignment: "center",
          },
        ]
      : []),
    {
      id: "VALUE",
      label: t("common:value"),
      style: {
        width: "156px",
      },
      type: "TEXT_COLUMN",
      alignment: "center",
    },
    ...(checkSMSSendVisible()
      ? [
          {
            id: "SEND_SMS",
            label: t("common:send_sms"),
            style: {
              width: "156px",
            },
            type: "TEXT_COLUMN",
            alignment: "center",
          },
        ]
      : []),
    {
      id: "SEND_EMAIL",
      label: t("common:send_email"),
      style: {
        width: "156px",
      },
      type: "TEXT_COLUMN",
      alignment: "center",
    },
    ...(isAccountLevel
      ? [
          {
            id: TIMETABLE_CONSTANTS.APPLIED_TO_SCHOOLS,
            label: t("attendance:applied_to_schools"),
            style: {
              width: "156px",
            },
            type: "POPOVER_COLUMN",
            alignment: "center",
          },
        ]
      : []),
    {
      id: TIMETABLE_CONSTANTS.CREATED_BY,
      label: t("common:created_by"),
      style: periodStyles.standardColumnStyle,
      type: "TEXT_COLUMN",
      alignment: "center",
    },
    ...(getIsAttendanceCodesSortingEnabled()
      ? [
          {
            id: "SORT_ORDER",
            label: t("common:sort_order"),
            type: "TEXT_COLUMN",
            alignment: "center",
            style: {
              width: "120px",
            },
          },
        ]
      : []),
  ];

  return getFinalColumnList({
    columnList: codeColumns,
    configuredColumns,
    showConfigurableColumns,
    requiredColumns,
  });
};

const bulkApplyCodesColumnList = ({ t }) => {
  return [
    {
      id: "CODE_NAME",
      label: t("common:name"),
      style: periodStyles.nameColumnStyle,
      type: "TEXT_COLUMN",
      isSticky: true,
    },
    {
      id: "CATEGORY",
      label: t("common:category"),
      type: "TEXT_COLUMN",
    },
    {
      id: "ABBREVIATION",
      label: t("common:abbreviation"),
      type: "TEXT_COLUMN",
      alignment: "center",
      style: {
        width: "156px",
      },
    },
    {
      id: "VALUE",
      label: t("common:value"),
      style: {
        width: "156px",
      },
      type: "CUSTOM",
      alignment: "center",
    },
    ...(checkSMSSendVisible()
      ? [
          {
            id: "SEND_SMS",
            label: t("attendance:sms_to_family"),
            style: {
              width: "156px",
            },
            type: "CUSTOM",
            alignment: "center",
          },
        ]
      : []),
    {
      id: "SEND_EMAIL",
      label: t("attendance:email_to_family"),
      style: {
        width: "156px",
      },
      type: "CUSTOM",
      alignment: "center",
    },
    {
      id: "ACTIONS",
      style: periodStyles.actionColumnStyle,
      type: "ACTIONS",
      alignment: "center",
    },
  ];
};

const bulkApplySchoolColumnList = ({ t }) => {
  return [
    {
      id: "SCHOOL_NAME",
      label: t("common:school_name"),
      style: periodStyles.nameColumnStyle,
      type: "TEXT_COLUMN",
      isSticky: true,
    },
    {
      id: "ACTIONS",
      style: periodStyles.actionColumnStyle,
      type: "ACTIONS",
      alignment: "center",
    },
  ];
};

const bulkApplyTiersStyles = {
  nameColumnStyle: {
    minWidth: "200px",
    maxWidth: "400px",
    flex: 1,
  },
  colorColumnStyle: {
    width: "68px",
  },
};

const bulkApplyTiersColumnList = ({ t }) => {
  return [
    {
      id: "PRESENCE_RANGE",
      label: t("attendance:presence_range"),
      style: bulkApplyTiersStyles.nameColumnStyle,
      type: "TEXT_COLUMN",
      isSticky: true,
    },
    {
      id: "TIER",
      label: t("attendance:tier"),
      style: bulkApplyTiersStyles.nameColumnStyle,
      type: "TEXT_COLUMN",
    },
    {
      id: "COLOR",
      label: t("common:color"),
      type: "CUSTOM",
      alignment: "center",
      style: bulkApplyTiersStyles.colorColumnStyle,
    },
  ];
};

export const getBulkApplyTableHeaders = ({ tabId, t }) => {
  switch (tabId) {
    case "ATTENDANCE_CODES":
      return bulkApplyCodesColumnList({ t });
    case "ATTENDANCE_TIERS":
      return bulkApplyTiersColumnList({ t });
    case "SCHOOLS":
      return bulkApplySchoolColumnList({ t });
  }
};

const schoolWiseInfoStyles = {
  nameColumnStyle: {
    maxWidth: "600px",
    minWidth: "248px",
  },
  standardColumnStyle: {
    width: "200px",
  },
  actionColumnStyle: {
    width: "104px",
  },
};

export const getSchoolWiseInfoColumnList = ({
  configuredColumns,
  showConfigurableColumns,
  t,
}) => {
  const requiredColumns = [
    {
      id: TIMETABLE_CONSTANTS.SCHOOL_NAME,
      label: t("common:school_name"),
      style: schoolWiseInfoStyles.nameColumnStyle,
      type: "AVATAR_WITH_TEXT",
      // viewMode: "NAME_AND_CUSTOM_SUBTEXT",
      viewMode: "NAME_ONLY",
      sortType: "toggle",
      hasSortingEnabled: true,
      isSticky: true,
    },
    {
      id: TIMETABLE_CONSTANTS.ACTIONS,
      style: schoolWiseInfoStyles.actionColumnStyle,
      type: "ACTIONS",
    },
  ];

  const schoolWiseInfoColumns = [
    {
      id: TIMETABLE_CONSTANTS.TIMETABLE_TEMPLATES,
      label: t("attendance:timetable_templates"),
      style: schoolWiseInfoStyles.standardColumnStyle,
      type: "POPOVER_COLUMN",
    },
    {
      id: TIMETABLE_CONSTANTS.DAY_CYCLES,
      label: t("attendance:day_cycles"),
      style: schoolWiseInfoStyles.standardColumnStyle,
      type: "POPOVER_COLUMN",
    },
    {
      id: TIMETABLE_CONSTANTS.PERIODS,
      label: t("attendance:periods"),
      style: schoolWiseInfoStyles.standardColumnStyle,
      type: "POPOVER_COLUMN",
      alignment: "center",
    },
    {
      id: TIMETABLE_CONSTANTS.BELL_SCHEDULES,
      label: t("attendance:bell_schedules"),
      style: schoolWiseInfoStyles.standardColumnStyle,
      type: "POPOVER_COLUMN",
      alignment: "center",
    },
    // {
    //   id: TIMETABLE_CONSTANTS.LAST_UPDATED_BY,
    //   label: "Last updated by",
    //   style: schoolWiseInfoStyles.standardColumnStyle,
    //   type: "AVATAR_WITH_TEXT",
    //   viewMode: "NAME_ONLY",
    // },
  ];

  return getFinalColumnList({
    columnList: schoolWiseInfoColumns,
    configuredColumns,
    showConfigurableColumns,
    requiredColumns,
  });
};

export const getSchoolWiseInfoColumnListMemoised = _.memoize(
  params => getSchoolWiseInfoColumnList(params),
  params => JSON.stringify(params)
);

export const getSchoolWiseConfigColumnList = ({
  configuredColumns,
  showConfigurableColumns,
  t,
  isHomeroomClassEnabled,
}) => {
  const requiredColumns = [
    {
      id: ATTENDANCE_CONSTANTS.SCHOOL_NAME,
      label: t("common:school_name"),
      style: schoolWiseInfoStyles.nameColumnStyle,
      type: "AVATAR_WITH_TEXT",
      // viewMode: "NAME_AND_CUSTOM_SUBTEXT",
      viewMode: "NAME_ONLY",
      sortType: "toggle",
      hasSortingEnabled: true,
      isSticky: true,
    },
    {
      id: ATTENDANCE_CONSTANTS.ACTIONS,
      style: schoolWiseInfoStyles.actionColumnStyle,
      type: "ACTIONS",
    },
  ];

  const schoolWiseInfoColumns = [
    {
      id: ATTENDANCE_CONSTANTS.ATTENDANCE_CODE,
      label: t("attendance:attendance_code_plural"),
      style: schoolWiseInfoStyles.standardColumnStyle,
      type: "POPOVER_COLUMN",
      alignment: "center",
    },
    {
      id: ATTENDANCE_CONSTANTS.ATTENDANCE_TIERS,
      label: t("attendance:attendance_tiers"),
      style: schoolWiseInfoStyles.standardColumnStyle,
      type: "POPOVER_COLUMN",
      alignment: "center",
    },
    {
      id: ATTENDANCE_GLOBAL_CONSTANTS.ATTENDANCE_RECORDING_TYPE,
      label: t("attendance:attendance_recorded_as"),
      style: schoolWiseInfoStyles.standardColumnStyle,
      type: "TEXT_COLUMN",
    },
    isHomeroomClassEnabled
      ? {
          id: ATTENDANCE_CONSTANTS.DAILY_ATTENDANCE_RECORDED_IN,
          label: t("attendance:daily_attendance_recorded_in"),
          style: schoolWiseInfoStyles.standardColumnStyle,
          type: "CUSTOM",
        }
      : {
          id: ATTENDANCE_CONSTANTS.LINK_PERIOD,
          label: t("attendance:link_period"),
          style: schoolWiseInfoStyles.standardColumnStyle,
          type: "CUSTOM",
        },
    {
      id: ATTENDANCE_GLOBAL_CONSTANTS.ATTENDANCE_RECORDING_FROM_DATE,
      label: t("attendance:start_marking_from"),
      style: schoolWiseInfoStyles.standardColumnStyle,
      type: "TEXT_COLUMN",
    },
    {
      id: ATTENDANCE_GLOBAL_CONSTANTS.ENABLE_ATTENDANCE_AUTO_MARKING,
      label: t("attendance:automark_students"),
      style: schoolWiseInfoStyles.standardColumnStyle,
      type: "CUSTOM",
      alignment: "center",
    },
    {
      id: ATTENDANCE_GLOBAL_CONSTANTS.ATTENDANCE_AUTO_MARKING_TIME,
      label: t("attendance:automark_students_at"),
      style: schoolWiseInfoStyles.standardColumnStyle,
      type: "TEXT_COLUMN",
    },
    {
      id: ATTENDANCE_GLOBAL_CONSTANTS.OVERALL_ATTENDANCE_PERCENTAGE_TYPE,
      label: t("attendance:calculate_overall_percent_using"),
      style: schoolWiseInfoStyles.standardColumnStyle,
      type: "TEXT_COLUMN",
    },
    {
      id:
        ATTENDANCE_GLOBAL_CONSTANTS.ATTENDANCE_OVERALL_PRESENCE_DECIMAL_NUMBER,
      label: t("attendance:format_of_percent"),
      style: schoolWiseInfoStyles.standardColumnStyle,
      type: "TEXT_COLUMN",
    },
  ];

  return getFinalColumnList({
    columnList: schoolWiseInfoColumns,
    configuredColumns,
    showConfigurableColumns,
    requiredColumns,
  });
};

export const getSchoolWiseConfigColumnListMemoised = _.memoize(
  params => getSchoolWiseConfigColumnList(params),
  params => JSON.stringify(params)
);

export const getDayCyclesColumnListMemoized = _.memoize(
  params => getDayCyclesColumnList(params),
  params => JSON.stringify(params)
);

export const getDayCyclesColumnList = ({
  configuredColumns,
  showConfigurableColumns,
  isAccountLevel,
  t,
}) => {
  const requiredColumns = [
    {
      id: DAY_CYCLE_TABLE_CONSTANTS.DAY_CYCLE_NAME,
      label: t("common:label_name", {
        label: t("attendance:day_cycle"),
      }),
      style: dayCycleStyles.cycleColumnStyle,
      type: "TEXT_COLUMN",
      sortType: "toggle",
      hasSortingEnabled: true,
      isSticky: true,
    },
    {
      id: DAY_CYCLE_TABLE_CONSTANTS.ACTIONS,
      style: dayCycleStyles.actionColumnStyle,
      type: "ACTIONS",
    },
  ];

  const dayCycleColumns = [
    {
      id: DAY_CYCLE_TABLE_CONSTANTS.NO_OF_DAYS,
      label: t("attendance:no_of_days_per_week"),
      style: dayCycleStyles.noOfDaysColumnStyle,
      type: "POPOVER_COLUMN",
    },
    {
      id: DAY_CYCLE_TABLE_CONSTANTS.USED_IN_TEMPLATES,
      label: t("attendance:used_in_label", {
        label: t("common:template_plural"),
      }),
      style: dayCycleStyles.appliedToColumnStyle,
      type: "POPOVER_COLUMN",
    },
    ...(isAccountLevel
      ? [
          {
            id: DAY_CYCLE_TABLE_CONSTANTS.APPLIED_TO_SCHOOLS,
            label: t("attendance:applied_to_schools"),
            style: dayCycleStyles.appliedToColumnStyle,
            type: "POPOVER_COLUMN",
          },
        ]
      : []),
    {
      id: DAY_CYCLE_TABLE_CONSTANTS.DAY_CYCLE_ID,
      label: t("attendance:day_cycle_id"),
      style: periodStyles.standardColumnStyle,
      type: "TEXT_COLUMN",
      alignment: "center",
    },
    {
      id: TIMETABLE_CONSTANTS.CREATED_BY,
      label: t("common:created_by"),
      style: periodStyles.standardColumnStyle,
      type: "TEXT_COLUMN",
      alignment: "center",
    },
  ];

  return getFinalColumnList({
    columnList: dayCycleColumns,
    configuredColumns,
    showConfigurableColumns,
    requiredColumns,
  });
};

export const getTemplateColumnListMemoized = _.memoize(
  params => getTemplateColumnList(params),
  params => JSON.stringify(params)
);

export const getTemplateColumnList = ({
  configuredColumns,
  showConfigurableColumns,
  isAccountLevel,
  t,
}) => {
  const requiredColumns = [
    {
      id: "TEMPLATE_NAME",
      label: t("common:label_name", {
        label: t("common:template"),
      }),
      style: templateStyles.cycleColumnStyle,
      type: "TEXT_COLUMN",
      sortType: "toggle",
      hasSortingEnabled: true,
      isSticky: true,
    },
    {
      id: DAY_CYCLE_TABLE_CONSTANTS.ACTIONS,
      style: templateStyles.actionColumnStyle,
      type: "ACTIONS",
    },
  ];

  const templateColumns = [
    {
      id: "DAY_CYCLE",
      label: t("attendance:day_cycle"),
      style: templateStyles.dayCycleStyle,
      type: "POPOVER_COLUMN",
    },
    {
      id: "BELL_SCHEDULES_USED",
      label: t("attendance:bell_schedules_used"),
      style: templateStyles.appliedToColumnStyle,
      type: "POPOVER_COLUMN",
    },
    {
      id: DAY_CYCLE_TABLE_CONSTANTS.NO_OF_DAYS,
      label: t("attendance:no_of_days_per_week"),
      style: dayCycleStyles.noOfDaysColumnStyle,
      type: "POPOVER_COLUMN",
    },
    ...(isAccountLevel
      ? [
          {
            id: DAY_CYCLE_TABLE_CONSTANTS.APPLIED_TO_SCHOOLS,
            label: t("attendance:applied_to_schools"),
            style: templateStyles.appliedToColumnStyle,
            type: "POPOVER_COLUMN",
          },
        ]
      : []),
    {
      id: "TEMPLATE_ID",
      label: t("attendance:template_id"),
      style: periodStyles.standardColumnStyle,
      type: "TEXT_COLUMN",
      alignment: "center",
    },
    {
      id: TIMETABLE_CONSTANTS.CREATED_BY,
      label: t("common:created_by"),
      style: periodStyles.standardColumnStyle,
      type: "TEXT_COLUMN",
      alignment: "center",
    },
  ];

  return getFinalColumnList({
    columnList: templateColumns,
    configuredColumns,
    showConfigurableColumns,
    requiredColumns,
  });
};

const dayCycleStyles = {
  cycleColumnStyle: {
    maxWidth: "600px",
    minWidth: "248px",
  },
  appliedToColumnStyle: {
    width: "150px",
  },
  noOfDaysColumnStyle: {
    width: "150px",
  },
  actionColumnStyle: {
    width: "60px",
    padding: "0px",
  },
};

const templateStyles = {
  cycleColumnStyle: {
    maxWidth: "600px",
    minWidth: "248px",
  },
  appliedToColumnStyle: {
    width: "150px",
  },
  dayCycleStyle: {
    width: "270px",
  },
  actionColumnStyle: {
    width: "88px",
    padding: "0px",
  },
};

const bellScheduleStyles = {
  scheduleColumnStyle: {
    maxWidth: "600px",
    minWidth: "248px",
  },
  appliedToColumnStyle: {
    width: "150px",
  },
  noOfPeriodsColumnStyle: {
    width: "150px",
  },
  actionColumnStyle: {
    width: "60px",
    padding: "0px",
  },
};

export const DAY_CYCLE_TABLE_CONSTANTS = {
  DAY_CYCLE_NAME: "DAY_CYCLE_NAME",
  USED_IN_TEMPLATES: "USED_IN_TEMPLATES",
  APPLIED_TO_SCHOOLS: "APPLIED_TO_SCHOOLS",
  NO_OF_DAYS: "NO_OF_DAYS",
  ACTIONS: "ACTIONS",
  DAY_CYCLE_ID: "DAY_CYCLE_ID",
};

export const TEMPLATE_CONSTANTS = {
  CREATE_TEMPLATE: "CREATE_TEMPLATE",
  MODIFY_TEMPLATE: "MODIFY_TEMPLATE",
};

export const CYCLE_CONSTANTS = {
  MULTI_WEEK: "MULTI_WEEK",
  ALTERNATE_DAYS: "ALTERNATE_DAYS",
  ROTATION_CYCLE: "ROTATION_CYCLE",
  WEEKLY_DEPENDENT_ROTATION: "WEEKLY_DEPENDENT_ROTATION",
  OPERATIONAL_DAYS: "OPERATIONAL_DAYS",
  SIMPLE_CYCLE: "SIMPLE_CYCLE",
  CUSTOM_CYCLE: "CUSTOM_CYCLE",
  PICK_A_CYCLE: "PICK_A_CYCLE",
  DEFINE_CYCLE: "DEFINE_CYCLE",
  CREATE_CYCLE: "CREATE_CYCLE",
  EDIT_CYCLE: "EDIT_CYCLE",
};

export const getDefaultCycleConfiguration = ({ cycleType }) => {
  switch (cycleType) {
    case CYCLE_CONSTANTS.MULTI_WEEK:
      return [
        {
          id: _.uniqueId("week_"),
          label: "Week A",
          abbreviation: "A",
          isLocked: true,
        },
        {
          id: _.uniqueId("week_"),
          label: "Week B",
          abbreviation: "B",
          isLocked: true,
        },
      ];
    case CYCLE_CONSTANTS.ALTERNATE_DAYS:
    case CYCLE_CONSTANTS.WEEKLY_DEPENDENT_ROTATION:
      return [
        {
          id: _.uniqueId("day_"),
          label: "Day 1",
          abbreviation: "D1",
          isLocked: true,
        },
        {
          id: _.uniqueId("day_"),
          label: "Day 2",
          abbreviation: "D2",
          isLocked: true,
        },
      ];
    case CYCLE_CONSTANTS.ROTATION_CYCLE:
      return [
        {
          id: _.uniqueId("day_"),
          label: "Day 1",
          abbreviation: "D1",
          isLocked: true,
        },
        {
          id: _.uniqueId("day_"),
          label: "Day 2",
          abbreviation: "D2",
          isLocked: true,
        },
        {
          id: _.uniqueId("day_"),
          label: "Day 3",
          abbreviation: "D3",
          isLocked: true,
        },
      ];
  }
};

export const getDefaultCycleRule = () => {
  return [
    {
      id: "1",
      weekdays: [1, 2],
      relation: "IS",
      rotationEntities: [],
    },
  ];
};

export const getBellScheduleColumnList = ({
  configuredColumns,
  showConfigurableColumns,
  isAccountLevel,
  t,
}) => {
  const requiredColumns = [
    {
      id: TIMETABLE_CONSTANTS.BELL_SCHEDULE_NAME,
      label: t("common:label_name", {
        label: t("attendance:bell_schedule"),
      }),
      style: bellScheduleStyles.scheduleColumnStyle,
      type: "TEXT_COLUMN",
      sortType: "toggle",
      hasSortingEnabled: true,
      isSticky: true,
    },
    {
      id: TIMETABLE_CONSTANTS.ACTIONS,
      style: bellScheduleStyles.actionColumnStyle,
      type: "ACTIONS",
    },
  ];

  const bellScheduleColumns = [
    {
      id: TIMETABLE_CONSTANTS.NO_OF_PERIODS,
      label: t("common:period_plural"),
      style: bellScheduleStyles.noOfPeriodsColumnStyle,
      type: "POPOVER_COLUMN",
      alignment: "center",
    },
    {
      id: TIMETABLE_CONSTANTS.USED_IN_TEMPLATES,
      label: t("attendance:used_in_label", {
        label: t("common:template_plural"),
      }),
      style: bellScheduleStyles.appliedToColumnStyle,
      type: "POPOVER_COLUMN",
      alignment: "center",
    },
    ...(isAccountLevel
      ? [
          {
            id: TIMETABLE_CONSTANTS.APPLIED_TO_SCHOOLS,
            label: t("attendance:applied_to_schools"),
            style: bellScheduleStyles.appliedToColumnStyle,
            type: "POPOVER_COLUMN",
            alignment: "center",
          },
        ]
      : []),
    {
      id: TIMETABLE_CONSTANTS.BELL_SCHEDULE_ID,
      label: t("attendance:bell_schedule_id"),
      style: bellScheduleStyles.noOfPeriodsColumnStyle,
      type: "TEXT_COLUMN",
    },
    {
      id: TIMETABLE_CONSTANTS.CREATED_BY,
      label: t("common:created_by"),
      style: bellScheduleStyles.appliedToColumnStyle,
      type: "TEXT_COLUMN",
    },
  ];
  return getFinalColumnList({
    columnList: bellScheduleColumns,
    configuredColumns,
    showConfigurableColumns,
    requiredColumns,
  });
};

export const getBellScheduleColumnListMemoised = _.memoize(
  params => getBellScheduleColumnList(params),
  params => JSON.stringify(params)
);

export const handleFilterChange = ({
  data,
  searchText,
  activeFilters,
  searchFields,
  setFilteredData,
  schools = [],
}) => {
  const filteredData = _.filter(data, item => {
    const matchesSearch =
      _.isEmpty(searchText) ||
      _.some(searchFields, field => {
        const value = _.get(item, field);
        return value && _.includes(_.toLower(value), _.toLower(searchText));
      });
    const matchesAllFilters = _.every(
      activeFilters,
      (filterValues, filterKey) => {
        if (_.isEmpty(filterValues)) return false;

        if (filterKey === "types") {
          return _.includes(filterValues, _.get(item, "type"));
        }

        if (filterKey === "schools") {
          const itemPrograms = _.get(item, "appliedCurriculumPrograms", []);
          const itemSchoolIds = itemPrograms.map(
            school => _.get(school, "value") || _.get(school, "id")
          );

          const allSchoolIds = _.map(schools, school => _.get(school, "id"));

          const isAllSelected = _.isEqual(
            _.sortBy(filterValues),
            _.sortBy(allSchoolIds)
          );
          if (isAllSelected) return true;

          if (_.isEmpty(itemSchoolIds)) {
            return false;
          }
          return _.some(itemSchoolIds, id => _.includes(filterValues, id));
        }
        return true;
      }
    );
    if (_.isEmpty(activeFilters)) return matchesSearch;
    return matchesSearch && matchesAllFilters;
  });

  setFilteredData(filteredData);
};

const getConfigurationTemplate = ({ t }) => {
  return [
    {
      uid: "CYCLES",
      title: t("attendance:cycles"),
      childConfigurations: [
        {
          title: t("attendance:allow_schools_manage_day_cycles"),
          uid: "ALLOW_SCHOOLS_TO_CREATE_AND_MANAGE_THEIR_OWN_DAY_CYCLES",
          perm: "Common:AllowToCreateAndManageDayCycle",
        },
      ],
    },
    {
      uid: "PERIODS_AND_BELL_SCHEDULES",
      title: t("attendance:periods_and_bell_schedules"),
      childConfigurations: [
        {
          title: t("attendance:allow_schools_adjust_period_timings"),
          uid: "ALLOW_SCHOOLS_TO_ADJUST_PERIOD_TIMINGS",
          perm: "Common:AllowToAdjustPeriodTimingInBellSchedules",
        },
        {
          title: t("attendance:allow_schools_manage_bell_schedules"),
          uid: "ALLOW_SCHOOLS_TO_CREATE_AND_MANAGE_THEIR_OWN_BELL_SCHEDULES",
          perm: "Common:AllowToCreateAndManageBellSchedule",
        },
        {
          title: t("attendance:allow_schools_manage_periods"),
          uid: "ALLOW_SCHOOLS_TO_CREATE_AND_MANAGE_NEW_PERIODS",
          perm: "Common:AllowToCreateAndManagePeriod",
        },
      ],
    },
    {
      uid: "TIMETABLE_TEMPLATES",
      title: t("attendance:timetable_templates"),
      childConfigurations: [
        {
          title: t("attendance:allow_schools_manage_timetable_templates"),
          uid: "ALLOW_SCHOOLS_TO_CREATE_THEIR_OWN_TIMETABLE_TEMPLATES",
          perm: "Common:AllowToCreateAndManageTimetableTemplate",
        },
      ],
    },
  ];
};

const getAttendanceConfigurationTemplate = ({ t }) => {
  return [
    {
      uid: "ATTENDANCE_CODES",
      title: t("attendance:attendance_codes"),
      childConfigurations: [
        {
          title: t("attendance:allow_schools_modify_attendance_values"),
          uid: "ALLOW_SCHOOLS_TO_MODIFY_ATTENDANCE_VALUES",
          uiType: "TOGGLE_WITH_EDIT",
          perm: "Common:AllowToUpdateAttendanceCodeValue",
        },
        {
          title: t("attendance:allow_schools_modify_notification_preferences"),
          uid: "ALLOW_SCHOOLS_TO_MODIFY_NOTIFICATION_PREFERENCES",
          uiType: "TOGGLE_WITH_EDIT",
          perm: "Common:AllowToUpdateAttendanceCodeNotificationSettings",
        },
        {
          title: t("attendance:allow_schools_create_manage_attendance_codes"),
          uid: "ALLOW_SCHOOLS_TO_CREATE_AND_MANAGE_ATTENDANCE_CODES",
          uiType: "TOGGLE_WITH_EDIT",
          perm: "Common:AllowToCreateAttendanceCode",
        },
        {
          title: t("attendance:allow_schools_modify_attendance_tiers"),
          uid: "ALLOW_SCHOOLS_TO_MODIFY_ATTENDANCE_TIERS",
          uiType: "TOGGLE_WITH_EDIT",
          perm: "Common:AllowToUpdateAttendanceTier",
        },
      ],
    },
  ];
};

const findConfigValue = ({ perm, configurations }) => {
  const configResponse = _.find(configurations, configuration =>
    _.some(
      configuration.configurations,
      config => _.get(config, "configuration") === perm
    )
  );

  if (configResponse) {
    const matchedConfig = _.find(
      configResponse.configurations,
      config => _.get(config, "configuration") === perm
    );

    return matchedConfig
      ? { value: _.get(matchedConfig, "value"), id: _.get(matchedConfig, "id") }
      : null;
  }
  return null;
};

export const mapConfigurationToValue = ({
  t,
  configurations,
  isAttendancePemissions = false,
}) => {
  const configurationTemplate = isAttendancePemissions
    ? getAttendanceConfigurationTemplate({
        t,
        configurations,
      })
    : getConfigurationTemplate({
        t,
        configurations,
      });
  return _.map(configurationTemplate, templateItem => {
    // Map value for each child configuration
    if (_.get(templateItem, "childConfigurations")) {
      templateItem.childConfigurations = _.map(
        _.get(templateItem, "childConfigurations"),
        childItem => {
          const { perm } = childItem;
          const configValue = findConfigValue({
            perm,
            configurations,
          });
          return {
            ...childItem,
            id: _.get(configValue, "id"),
            value: _.get(configValue, "value"),
            perm,
          };
        }
      );
    }

    return templateItem;
  });
};

export const getEnabledConfigSchoolCount = ({
  allConfigurations,
  configurationId,
  schools,
}) => {
  const schoolSpecificConfigurations = _.slice(allConfigurations, 1);

  const schoolConfigStatusList = _.map(schools, school => {
    const currentSchoolConfiguration = _.filter(
      schoolSpecificConfigurations,
      config =>
        _.some(
          _.get(config, "entityGroups"),
          group => _.get(group, "entityId") === _.get(school, "id")
        )
    );

    const schoolSpecificSetting =
      currentSchoolConfiguration &&
      _.find(
        _.flatMap(currentSchoolConfiguration, "configurations"),
        config => _.get(config, "id") === configurationId
      );

    const isSchoolSettingEnabled =
      schoolSpecificSetting && _.has(schoolSpecificSetting, "value")
        ? JSON.parse(_.get(schoolSpecificSetting, "value"))
        : false;

    return {
      ...school,
      isEnabled: Boolean(isSchoolSettingEnabled),
    };
  });

  const enabledSchoolConfigurations = _.filter(
    schoolConfigStatusList,
    "isEnabled"
  );

  return {
    schoolsWithPermissionCount: _.size(enabledSchoolConfigurations),
    totalSchoolsCount: _.size(schools),
    enabledSchoolConfigurations,
  };
};

export const getConfigurationUpdateInput = ({
  currentValue,
  id,
  curriculumProgramId,
  schoolIds,
}) => {
  const entityGroups = currentValue
    ? [
        {
          entityType: "CURRICULUM_PROGRAM",
          entityId: curriculumProgramId,
        },
      ]
    : [
        {
          entityType: "CURRICULUM_PROGRAM",
          entityId: curriculumProgramId,
        },
        ..._.map(schoolIds, schoolID => ({
          entityType: "CURRICULUM_PROGRAM",
          entityId: schoolID,
        })),
      ];

  return [
    {
      id,
      valueType: "BOOLEAN",
      entityGroups,
      value: JSON.stringify(currentValue),
    },
  ];
};

export const getExampleCycleConfiguration = ({ cycleType }) => {
  switch (cycleType) {
    case CYCLE_CONSTANTS.MULTI_WEEK:
      return [
        {
          rotationEntity: {
            id: "A",
            label: "Week A",
            abbreviation: "A",
            isLocked: true,
            status: "NEW",
          },
          isStartCycle: false,
        },
        {
          rotationEntity: {
            id: "B",
            label: "Week B",
            abbreviation: "B",
            isLocked: true,
            status: "NEW",
          },
          isStartCycle: false,
        },
      ];
    case CYCLE_CONSTANTS.ALTERNATE_DAYS:
    case CYCLE_CONSTANTS.WEEKLY_DEPENDENT_ROTATION:
      return [
        {
          rotationEntity: {
            id: "A",
            label: "Day A",
            abbreviation: "A",
            isLocked: true,
            status: "NEW",
          },
          isStartCycle: false,
        },
        {
          rotationEntity: {
            id: "B",
            label: "Day B",
            abbreviation: "B",
            isLocked: true,
            status: "NEW",
          },
          isStartCycle: false,
        },
      ];
    case CYCLE_CONSTANTS.ROTATION_CYCLE:
      return [
        {
          rotationEntity: {
            id: "A",
            label: "Day A",
            abbreviation: "A",
            isLocked: true,
            status: "NEW",
          },
          isStartCycle: true,
        },
        {
          rotationEntity: {
            id: "B",
            label: "Day B",
            abbreviation: "B",
            isLocked: true,
            status: "NEW",
          },
          isStartCycle: false,
        },
        {
          rotationEntity: {
            id: "C",
            label: "Day C",
            abbreviation: "C",
            isLocked: true,
            status: "NEW",
          },
          isStartCycle: false,
        },
        {
          rotationEntity: {
            id: "D",
            label: "Day D",
            abbreviation: "D",
            isLocked: true,
            status: "NEW",
          },
          isStartCycle: false,
        },
      ];
  }
};

export const getExampleCycleRule = () => {
  return [
    {
      id: "rule_1",
      weekdays: [1],
      relation: "IS",
      rotationEntities: [
        {
          rotationEntity: {
            id: "A",
            label: "Day A",
            abbreviation: "A",
          },
          isStartCycle: false,
        },
      ],
      status: "NEW",
    },
    {
      id: "rule_2",
      weekdays: [2],
      relation: "IS",
      rotationEntities: [
        {
          rotationEntity: {
            id: "B",
            label: "Day B",
            abbreviation: "B",
          },
          isStartCycle: false,
        },
      ],
      status: "NEW",
    },
    {
      id: "rule_3",
      weekdays: [3],
      relation: "CYCLES",
      rotationEntities: [
        {
          rotationEntity: {
            id: "C",
            label: "Day C",
            abbreviation: "C",
          },
          isStartCycle: false,
        },
        {
          rotationEntity: {
            id: "D",
            label: "Day D",
            abbreviation: "D",
          },
          isStartCycle: true,
        },
      ],
      status: "NEW",
    },
    {
      id: "rule_4",
      weekdays: [4, 5],
      relation: "CYCLES",
      rotationEntities: [
        {
          rotationEntity: {
            id: "A",
            label: "Day A",
            abbreviation: "A",
          },
          isStartCycle: false,
        },
        {
          rotationEntity: {
            id: "C",
            label: "Day C",
            abbreviation: "C",
          },
          isStartCycle: true,
        },
      ],
      status: "NEW",
    },
  ];
};

export const getExampleBellSchedulesMap = ({ cycleType }) => {
  switch (cycleType) {
    case CYCLE_CONSTANTS.MULTI_WEEK:
      return {
        "A-MON": [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }],
        "A-TUE": [{ id: 5 }, { id: 6 }, { id: 7 }],
        "A-WED": [{ id: 8 }, { id: 9 }, { id: 10 }],
        "A-THU": [{ id: 11 }, { id: 12 }, { id: 13 }, { id: 45 }],
        "A-FRI": [{ id: 14 }, { id: 15 }, { id: 16 }],
        "A-SAT": [{ id: 17 }, { id: 18 }, { id: 19 }],
        "A-SUN": [{ id: 20 }, { id: 21 }, { id: 22 }],
        "B-MON": [{ id: 23 }, { id: 24 }, { id: 25 }],
        "B-TUE": [{ id: 27 }, { id: 28 }, { id: 29 }, { id: 26 }],
        "B-WED": [{ id: 30 }, { id: 31 }, { id: 32 }],
        "B-THU": [{ id: 33 }, { id: 34 }, { id: 35 }],
        "B-FRI": [{ id: 36 }, { id: 37 }, { id: 38 }, { id: 47 }],
        "B-SAT": [{ id: 39 }, { id: 40 }, { id: 41 }, { id: 48 }],
        "B-SUN": [{ id: 42 }, { id: 43 }, { id: 44 }],
      };
    case CYCLE_CONSTANTS.ALTERNATE_DAYS:
      return {
        A: [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }],
        B: [{ id: 5 }, { id: 6 }, { id: 7 }, { id: 8 }, { id: 9 }],
      };
    case CYCLE_CONSTANTS.ROTATION_CYCLE:
      return {
        A: [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }],
        B: [{ id: 5 }, { id: 6 }, { id: 7 }],
        C: [{ id: 8 }, { id: 9 }, { id: 10 }, { id: 11 }],
        D: [{ id: 12 }, { id: 13 }, { id: 14 }],
      };
    case CYCLE_CONSTANTS.WEEKLY_DEPENDENT_ROTATION:
      return {
        "0-SUN": [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }],
        "0-MON": [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }],
        "0-TUE": [{ id: 5 }, { id: 6 }, { id: 7 }],
        "0-WED": [{ id: 8 }, { id: 9 }],
        "0-THU": [{ id: 12 }, { id: 13 }, { id: 14 }, { id: 45 }],
        "0-FRI": [{ id: 15 }, { id: 16 }, { id: 17 }],
        "0-SAT": [{ id: 18 }, { id: 19 }, { id: 20 }],
        "1-SUN": [{ id: 21 }, { id: 22 }, { id: 23 }, { id: 24 }],
        "1-MON": [{ id: 25 }, { id: 26 }, { id: 27 }, { id: 28 }],
        "1-TUE": [{ id: 29 }, { id: 30 }, { id: 31 }],
        "1-WED": [{ id: 33 }, { id: 34 }],
        "1-THU": [{ id: 36 }, { id: 37 }, { id: 38 }, { id: 35 }],
        "1-FRI": [{ id: 39 }, { id: 40 }, { id: 41 }],
        "1-SAT": [{ id: 42 }, { id: 43 }, { id: 44 }],
      };
  }
};

export const getCycleType = ({ cycleType }) => {
  switch (cycleType) {
    case "MULTI_WEEK":
      return CYCLE_CONSTANTS.MULTI_WEEK;
    case "ALTERNATE_DAY_CYCLE":
      return CYCLE_CONSTANTS.ALTERNATE_DAYS;
    case "ROTATION_CYCLE_SIMPLE":
    case "ROTATION_CYCLE_CUSTOM":
      return CYCLE_CONSTANTS.ROTATION_CYCLE;
    case "DEPENDENT_ON_WEEKDAYS_CYCLE":
      return CYCLE_CONSTANTS.WEEKLY_DEPENDENT_ROTATION;
    case "OPERATIONAL_DAYS":
      return CYCLE_CONSTANTS.OPERATIONAL_DAYS;
  }
};

export const getCycleMode = ({ cycleType, rotationCycleType }) => {
  switch (cycleType) {
    case CYCLE_CONSTANTS.MULTI_WEEK:
      return "MULTI_WEEK";
    case CYCLE_CONSTANTS.ALTERNATE_DAYS:
      return "ALTERNATE_DAY_CYCLE";
    case CYCLE_CONSTANTS.ROTATION_CYCLE:
      return rotationCycleType === CYCLE_CONSTANTS.SIMPLE_CYCLE
        ? "ROTATION_CYCLE_SIMPLE"
        : "ROTATION_CYCLE_CUSTOM";
    case CYCLE_CONSTANTS.WEEKLY_DEPENDENT_ROTATION:
      return "DEPENDENT_ON_WEEKDAYS_CYCLE";
    case CYCLE_CONSTANTS.OPERATIONAL_DAYS:
      return "OPERATIONAL_DAYS";
  }
};

const getDayCyclePreviewMultiWeekHeaders = ({
  rotationEntities,
  operationalDays,
  DayCycleHeader,
  columnStyles,
}) => {
  const getWeekTableHeaders = ({ id, label }) => {
    const weekHeader = {
      ...columnStyles,
      key: id,
      children: _.map(operationalDays, day => `${id}-${COLUMNS[day]}`),
      value: <DayCycleHeader value={label} colorId={id} />,
      parent: "root",
      level: 0,
    };

    const weekDayHeaders = _.map(operationalDays, day => ({
      ...columnStyles,
      key: `${id}-${COLUMNS[day]}`,
      value: <DayCycleHeader value={COLUMNS[day]} colorId={id} />,
      parent: id,
      level: 1,
    }));

    return [weekHeader, ...weekDayHeaders];
  };

  return _.map(rotationEntities, ({ rotationEntity: { id, label } }) =>
    getWeekTableHeaders({ id, label })
  );
};

export const getDayCyclePreviewTableHeaders = ({
  cycleType,
  rotationEntities,
  operationalDays,
  DayCycleHeader,
  maxTables,
  dayToRelationMap,
  dayToCycleMap,
  dayToWeekdayMap,
}) => {
  const columnStyles = {
    alignment: "center",
    style: {
      padding: "0",
      textAlign: "center",
      width: "10%",
    },
    isEnabled: true,
  };

  switch (cycleType) {
    case CYCLE_CONSTANTS.MULTI_WEEK:
      return getDayCyclePreviewMultiWeekHeaders({
        rotationEntities,
        operationalDays,
        DayCycleHeader,
        columnStyles,
      });
    case CYCLE_CONSTANTS.ALTERNATE_DAYS:
    case CYCLE_CONSTANTS.ROTATION_CYCLE:
      return [
        _.map(rotationEntities, ({ rotationEntity: { id, label } }, index) => ({
          ...columnStyles,
          key: `${id}_${index}`,
          value: <DayCycleHeader value={label} colorId={id} />,
          isEnabled: true,
        })),
      ];
    case CYCLE_CONSTANTS.WEEKLY_DEPENDENT_ROTATION:
      return _.times(maxTables, tableIndex =>
        _.map(operationalDays, dayIndex => {
          const dayRelation = dayToRelationMap[dayIndex];
          const cycleDays = dayToCycleMap[dayIndex];

          const dayWeekdays = dayToWeekdayMap[dayIndex];

          if (dayRelation === "CYCLES") {
            const currentDayInCycle = _.indexOf(dayWeekdays, dayIndex);

            const startDayIndex = _.max([
              _.findIndex(cycleDays, {
                isStartCycle: true,
              }),
              0,
            ]);

            const cyclePattenIndex =
              tableIndex * _.size(dayWeekdays) +
              currentDayInCycle +
              startDayIndex;

            const currentPattern =
              cycleDays[cyclePattenIndex % _.size(cycleDays)];

            return {
              ...columnStyles,
              key: `${tableIndex}-${COLUMNS[dayIndex]}`,
              value: (
                <DayCycleHeader
                  value={_.get(currentPattern, "label")}
                  colorId={_.get(currentPattern, "id")}
                  operationalDay={_.capitalize(COLUMNS[dayIndex])}
                />
              ),
              isEnabled: true,
            };
          } else if (dayRelation === "IS") {
            return {
              ...columnStyles,
              key: `${tableIndex}-${COLUMNS[dayIndex]}`,
              value: (
                <DayCycleHeader
                  value={_.get(cycleDays, "[0].label")}
                  colorId={_.get(cycleDays, "[0].id")}
                  operationalDay={_.capitalize(COLUMNS[dayIndex])}
                />
              ),
              isEnabled: true,
            };
          } else {
            return {
              ...columnStyles,
              key: `${tableIndex}-${COLUMNS[dayIndex]}`,
              value: (
                <DayCycleHeader
                  value={_.get(cycleDays, "[0].label")}
                  colorId={_.get(cycleDays, "[0].id")}
                  operationalDay={_.capitalize(COLUMNS[dayIndex])}
                />
              ),
              isEnabled: false,
            };
          }
        })
      );
    case CYCLE_CONSTANTS.OPERATIONAL_DAYS:
      return [
        _.map(operationalDays, operationalDay => ({
          ...columnStyles,
          key: operationalDay,
          value: (
            <DayCycleHeader
              value={moment().day(operationalDay).format("dddd")}
              colorId={_.toString(operationalDay)}
            />
          ),
          isEnabled: true,
        })),
      ];
  }
};

export const getRuleMapping = ({ cycleRule }) => {
  const dayToRelationMap = _.reduce(
    cycleRule,
    (result, rule) => {
      return {
        ...result,
        ..._.zipObject(
          _.get(rule, "weekdays"),
          _.fill(
            Array(_.size(_.get(rule, "weekdays"))),
            _.get(rule, "relation")
          )
        ),
      };
    },
    {}
  );

  const dayToCycleMap = _.reduce(
    cycleRule,
    (result, rule) => {
      const daysMapping = _.zipObject(
        _.get(rule, "weekdays"),
        _.map(_.get(rule, "weekdays"), () =>
          _.map(
            _.get(rule, "rotationEntities"),
            ({ rotationEntity, isStartCycle }) => ({
              ...rotationEntity,
              isStartCycle,
            })
          )
        )
      );
      return { ...result, ...daysMapping };
    },
    {}
  );

  const dayToWeekdayMap = _.reduce(
    cycleRule,
    (result, rule) => {
      _.forEach(_.get(rule, "weekdays"), day => {
        result[day] = [..._.get(rule, "weekdays")];
      });
      return result;
    },
    {}
  );

  return { dayToRelationMap, dayToCycleMap, dayToWeekdayMap };
};

export const getBellScheduleMap = ({
  cycleType,
  bellScheduleMapping,
  maxTables,
  dayToRelationMap,
  dayToCycleMap,
  dayToWeekdayMap,
  operationalDays,
}) => {
  if (cycleType === CYCLE_CONSTANTS.WEEKLY_DEPENDENT_ROTATION) {
    const mappingIndexMap = {};

    const bellScheduleToDayCycleMap = _.reduce(
      bellScheduleMapping,
      (acc, item, index) => {
        mappingIndexMap[_.get(item, "cycleDay.value")] = index;

        return {
          ...acc,
          [_.get(item, "cycleDay.value")]: _.map(
            _.get(item, "bellSchedule.periodsEdge.periods"),
            ({ startTime, endTime, period }) => ({
              startTime,
              endTime,
              ...period,
            })
          ),
        };
      },
      {}
    );

    const bellScheduleMap = {};

    _.times(maxTables, tableIndex => {
      _.each(operationalDays, dayIndex => {
        const dayRelation = dayToRelationMap[dayIndex];
        const cycleDays = dayToCycleMap[dayIndex];

        const dayWeekdays = dayToWeekdayMap[dayIndex];

        let rotationDayId;

        if (dayRelation === "CYCLES") {
          const currentDayInCycle = _.indexOf(dayWeekdays, dayIndex);

          const startDayIndex = _.max([
            _.findIndex(cycleDays, {
              isStartCycle: true,
            }),
            0,
          ]);

          const cyclePattenIndex =
            tableIndex * _.size(dayWeekdays) +
            currentDayInCycle +
            startDayIndex;

          const currentPattern =
            cycleDays[cyclePattenIndex % _.size(cycleDays)];

          rotationDayId = _.get(currentPattern, "id");
        } else if (dayRelation === "IS") {
          rotationDayId = _.get(cycleDays, "[0].id");
        }

        const key = `${tableIndex}-${COLUMNS[dayIndex]}`;
        const hasRotationDay = !_.isNil(mappingIndexMap[rotationDayId]);
        const hasDay = !_.isNil(mappingIndexMap[dayIndex]);

        bellScheduleMap[key] = (() => {
          // If only one mapping exists, use it
          if (!hasRotationDay) return bellScheduleToDayCycleMap[dayIndex];
          if (!hasDay) return bellScheduleToDayCycleMap[rotationDayId];

          // If both exist, use the one with lower index
          return mappingIndexMap[rotationDayId] < mappingIndexMap[dayIndex]
            ? bellScheduleToDayCycleMap[rotationDayId]
            : bellScheduleToDayCycleMap[dayIndex];
        })();
      });
    });

    return bellScheduleMap;
  }

  return _.reduce(
    bellScheduleMapping,
    (acc, item) => ({
      ...acc,
      [_.get(item, "id")]: _.map(
        _.get(item, "bellSchedule.periodsEdge.periods"),
        ({ startTime, endTime, period }) => ({
          startTime,
          endTime,
          ...period,
        })
      ),
    }),
    {}
  );
};

export const getBellScheduleMapForTimetablePreview = ({
  cycleType,
  rotationEntities,
  operationalDays,
  selectedMapping,
  bellSchedulesMap = {},
}) => {
  switch (cycleType) {
    case CYCLE_CONSTANTS.MULTI_WEEK:
      return _.flatMap(
        rotationEntities,
        ({ rotationEntity: { id, abbreviation } }) =>
          _.map(operationalDays, day => {
            const selectedMap = _.find(
              selectedMapping,
              ({ weekDay, rotationEntity }) =>
                weekDay === day && _.get(rotationEntity, "id") === id
            );

            const selectedBellScheduleId = _.get(
              selectedMap,
              "bellSchedule.id",
              null
            );

            const selectedBellSchedule = !_.isNil(selectedBellScheduleId)
              ? {
                  ..._.get(selectedMap, "bellSchedule", {}),
                  ...bellSchedulesMap[selectedBellScheduleId],
                  value: selectedBellScheduleId,
                }
              : null;

            return {
              id: `${id}-${COLUMNS[day]}`,
              label: moment().day(day).format("dddd"),
              abbreviation,
              bellSchedule: selectedBellSchedule,
            };
          })
      );
    case CYCLE_CONSTANTS.ALTERNATE_DAYS:
    case CYCLE_CONSTANTS.ROTATION_CYCLE:
      return _.map(rotationEntities, ({ rotationEntity }) => {
        const selectedMap = _.find(
          selectedMapping,
          ({ rotationEntity: mapRotationEntity }) =>
            _.get(mapRotationEntity, "id") === _.get(rotationEntity, "id")
        );

        const selectedBellScheduleId = _.get(
          selectedMap,
          "bellSchedule.id",
          null
        );

        const selectedBellSchedule = !_.isNil(selectedBellScheduleId)
          ? {
              ..._.get(selectedMap, "bellSchedule", {}),
              ...bellSchedulesMap[selectedBellScheduleId],
              value: selectedBellScheduleId,
            }
          : null;

        return {
          ...rotationEntity,
          bellSchedule: selectedBellSchedule,
        };
      });
    case CYCLE_CONSTANTS.WEEKLY_DEPENDENT_ROTATION:
      return _.map(
        selectedMapping,
        ({ id, weekDay, rotationEntity, bellSchedule }) => {
          const selectedBellSchedule = {
            ...bellSchedule,
            ...bellSchedulesMap[_.get(bellSchedule, "id")],
            value: _.get(bellSchedule, "id"),
          };

          const cycleDay = !_.isNil(weekDay)
            ? {
                value: weekDay,
                label: moment().day(weekDay).format("dddd"),
                isWeekDay: true,
              }
            : {
                ...rotationEntity,
                value: _.get(rotationEntity, "id"),
                isWeekDay: false,
              };

          return {
            id,
            label: "",
            cycleDay,
            bellSchedule: selectedBellSchedule,
          };
        }
      );

    case CYCLE_CONSTANTS.OPERATIONAL_DAYS:
      return _.map(operationalDays, operationalDay => {
        const selectedMap = _.find(
          selectedMapping,
          ({ weekDay }) => weekDay === operationalDay
        );

        const selectedBellScheduleId = _.get(
          selectedMap,
          "bellSchedule.id",
          null
        );

        const selectedBellSchedule = !_.isNil(selectedBellScheduleId)
          ? {
              ..._.get(selectedMap, "bellSchedule", {}),
              ...bellSchedulesMap[selectedBellScheduleId],
              value: selectedBellScheduleId,
            }
          : null;

        return {
          id: operationalDay,
          label: moment().day(operationalDay).format("dddd"),
          bellSchedule: selectedBellSchedule,
        };
      });
  }
};

export const CYCLE_WITHOUT_START_DAY = [
  CYCLE_CONSTANTS.WEEKLY_DEPENDENT_ROTATION,
  CYCLE_CONSTANTS.OPERATIONAL_DAYS,
  CYCLE_CONSTANTS.ALTERNATE_DAYS,
];

export const BACKGROUND_COLOR = [
  "var(--decorative-background-pink)",
  "var(--decorative-background-orange)",
  "var(--decorative-background-violet)",
  "var(--decorative-background-teal)",
  "var(--decorative-background-green)",
  "var(--decorative-background-purple)",
  "var(--decorative-background-blue)",
];

export const getColorCodeHash = str =>
  _.sum(_.map(str, char => char.charCodeAt(0))) % _.size(BACKGROUND_COLOR);

export const getTimetableConfigurationValue = ({
  configurations,
  configKey,
}) => {
  const configuration = _.find(configurations, { configuration: configKey });

  return _.get(configuration, "value", null) === "true";
};

export const getTimetableConfigurationsQueryVariables = ({
  curriculumProgramId,
  configurations,
}) => {
  return {
    configurationEntityGroupFilters: [
      {
        configurationEntityGroups: [
          {
            entityType: "CURRICULUM_PROGRAM",
            entityId: curriculumProgramId,
          },
        ],
        configurations,
      },
    ],
    isAdminPage: true,
    isSettingsPage: false,
    isCourseModuleSetting: false,
  };
};

export const getTimetableConfigurationsQueryVariablesMemoize = _.memoize(
  params => getTimetableConfigurationsQueryVariables(params),
  ({ curriculumProgramId, configurations }) =>
    `${curriculumProgramId}-${_.join(configurations, "-")}`
);

export const getGlobalConstantMap = ({ globalConstants }) => {
  return _.chain(globalConstants)
    .groupBy("curriculumProgram.id")
    .mapValues(group => _.keyBy(group, "name"))
    .mapValues(programConstants =>
      _.mapValues(programConstants, item => _.get(item, "value", null))
    )
    .value();
};

export const getAttendanceRecordingTypeLabel = ({ t, recordingType }) => {
  switch (recordingType) {
    case ATTENDANCE_CONSTANTS.EACH_PERIOD_WITH_ONCE_A_DAY:
      return t("common:entity1_and_entity2", {
        entity1: t("common:daily"),
        entity2: t("attendance:period_wise"),
      });
    case ATTENDANCE_CONSTANTS.EACH_PERIOD:
      return t("attendance:period_wise");
    case ATTENDANCE_CONSTANTS.ONCE_A_DAY:
      return t("common:daily");
    default:
      return "-";
  }
};

export const getAttendanceCalculationLabel = ({
  t,
  attendanceDecimal,
  attendanceCalculation,
}) => {
  if (_.isNil(attendanceDecimal) || _.isNil(attendanceCalculation)) {
    return "-";
  }

  let decimalLabel = "";
  let calculationLabel = "";

  switch (attendanceDecimal) {
    case "0":
      decimalLabel = t("common:no_decimal_values");
      break;
    case "1":
      decimalLabel = "1 decimal";
      break;
    case "2":
      decimalLabel = "2 decimal";
  }

  switch (attendanceCalculation) {
    case "ROUND":
      calculationLabel = t("common:rounded_lowercase");
      break;
    case "TRUNCATE":
      calculationLabel = t("common:truncated_lowercase");
      break;
  }

  return `${decimalLabel}, ${calculationLabel}`;
};

export const getDailyAttendanceRecordedInLabel = ({
  t,
  dailyAttendanceRecordingSetting,
  defaultPeriod,
}) => {
  switch (dailyAttendanceRecordingSetting) {
    case "ALL_CLASS":
      return { label: t("common:all_classes_plural") };
    case "HOMEROOM_CLASS":
      return { label: t("attendance:homeroom_classes") };
    case "SCHEDULE_PERIOD":
      return {
        label: t("attendance:scheduled_period"),
        schedulePeriod: _.get(defaultPeriod, "label"),
      };
    default:
      return {};
  }
};

export const getAttendanceBulkApplyTabs = ({
  isUpdateBulkApply,
  isHomeroomClassesEnabled,
  isAttendanceTierSelected,
  t,
}) => [
  {
    id: "ATTENDANCE_CODES",
    label: t("attendance:attendance_codes"),
    subLabel: t("attendance:attendance_codes_sub_label"),
    type: "TABLE",
    icon: <AddOutlined />,
    searchPlaceholder: t("attendance:search_codes_placeholder"),
    buttonLabel: t("common:add_with_label", {
      label: t("attendance:attendance_codes"),
    }),
  },
  {
    id: "ATTENDANCE_TIERS",
    label: t("attendance:attendance_tiers"),
    subLabel: t("attendance:attendance_tiers_sub_label"),
    type: "TABLE",
    icon: isAttendanceTierSelected ? <PencilLineOutlined /> : <AddOutlined />,
    buttonLabel: isAttendanceTierSelected
      ? t("attendance:replace_attendance_tier_set")
      : t("attendance:select_attendance_tier_set"),
  },
  {
    id: "ATTENDANCE_MARKING",
    label: t("attendance:attendance_marking"),
    subLabel: t("attendance:attendance_marking_sub_label"),
    type: "CONFIGURATION",
    configurations: [
      {
        id: ATTENDANCE_GLOBAL_CONSTANTS.ATTENDANCE_RECORDING_TYPE,
        label: t("attendance:attendance_recording_as"),
        subLabel: t("attendance:attendance_recording_as_sub_label"),
        configType: "SELECT",
      },
      isHomeroomClassesEnabled
        ? {
            id: ATTENDANCE_CONSTANTS.DAILY_ATTENDANCE_RECORDED_IN,
            label: t("attendance:daily_attendance_in"),
            subLabel: t("attendance:daily_attendance_in_sub_label"),
            configType: "SELECT",
          }
        : {
            id: ATTENDANCE_CONSTANTS.LINK_PERIOD,
            label: t("attendance:link_period"),
            subLabel: t("attendance:link_period_sub_label"),
            configType: "SELECT",
          },
      {
        id: ATTENDANCE_GLOBAL_CONSTANTS.ATTENDANCE_RECORDING_FROM_DATE,
        label: t("attendance:start_marking_from"),
        subLabel: t("attendance:start_marking_from_sub_label"),
        configType: "SELECT",
      },
      {
        id: ATTENDANCE_GLOBAL_CONSTANTS.ENABLE_ATTENDANCE_AUTO_MARKING,
        label: t("attendance:auto_mark_present"),
        subLabel: t("attendance:auto_mark_present_sub_label"),
        configType: "TOGGLE",
      },
      {
        id: ATTENDANCE_GLOBAL_CONSTANTS.ATTENDANCE_AUTO_MARKING_TIME,
        label: t("attendance:time_of_marking"),
        subLabel: t("attendance:time_of_marking_sub_label"),
        configType: "SELECT",
      },
    ],
  },
  {
    id: "ATTENDANCE_CALCULATION",
    label: t("attendance:attendance_calculation"),
    subLabel: t("attendance:attendance_calculation_sub_label"),
    type: "CONFIGURATION",
    configurations: [
      {
        id: "OVERALL_ATTENDANCE_PERCENTAGE_TYPE",
        label: t("attendance:use_records_from"),
        subLabel: t("attendance:use_records_from_sub_label"),
        configType: "SELECT",
      },
      {
        id: "ATTENDANCE_OVERALL_PRESENCE_DECIMAL_NUMBER",
        label: t("attendance:format_of_percentage_value"),
        subLabel: t("attendance:format_percentage_sub_label"),
        configType: "SELECT",
      },
    ],
  },
  ...(!isUpdateBulkApply
    ? [
        {
          id: "SCHOOLS",
          tabLabel: t("common:school_plural"),
          label: t("attendance:apply_to_schools"),
          subLabel: t("attendance:attendance_calculation_sub_label"),
          type: "TABLE",
          searchPlaceholder: t("attendance:search_schools_placeholder"),
          icon: <AddOutlined />,
          buttonLabel: t("common:add_with_label", {
            label: t("common:school_plural"),
          }),
        },
      ]
    : []),
  {
    id: "ATTENDANCE_PERMISSIONS",
    label: t("common:permission_plural"),
    subLabel: t("attendance:permissions_sub_label"),
    type: "CONFIGURATION",
    configurations: [
      {
        id: "AllowToUpdateAttendanceCodeValue",
        label: t("attendance:allow_schools_modify_attendance_values"),
        configType: "TOGGLE",
      },
      {
        id: "AllowToUpdateAttendanceCodeNotificationSettings",
        label: t("attendance:allow_schools_modify_notification_preferences"),
        configType: "TOGGLE",
      },
      {
        id: "AllowToCreateAttendanceCode",
        label: t("attendance:allow_schools_create_manage_attendance_codes"),
        configType: "TOGGLE",
      },
      {
        id: "AllowToUpdateAttendanceTier",
        label: t("attendance:allow_schools_modify_attendance_tiers"),
        configType: "TOGGLE",
      },
    ],
  },
];

export const getConfigurationInfo = ({
  t,
  id,
  selectedConfiguration,
  academicYearStartDate,
}) => {
  switch (id) {
    case "ATTENDANCE_RECORDING_TYPE":
      return {
        label: getAttendanceRecordingTypeLabel({
          t,
          recordingType: _.get(selectedConfiguration, id),
        }),
      };
    case "LINK_PERIOD":
      return {
        label: _.get(selectedConfiguration, `${id}.label`),
        subLabel: `${_.startCase(
          _.toLower(
            _.get(selectedConfiguration, "HOMEROOM_PERIOD_ATTENDANCE_SYNC_TYPE")
          )
        )} sync`,
      };
    case "DAILY_ATTENDANCE_RECORDED_IN": {
      const { label, schedulePeriod } = getDailyAttendanceRecordedInLabel({
        t,
        dailyAttendanceRecordingSetting: _.get(selectedConfiguration, id),
        defaultPeriod: _.get(selectedConfiguration, "LINK_PERIOD"),
      });
      return {
        label,
        ...(schedulePeriod ? { subLabel: schedulePeriod } : {}),
      };
    }

    case "ATTENDANCE_AUTO_MARKING_TIME":
      return {
        label: moment(_.get(selectedConfiguration, id), "HH:mm").format(
          "h:mm A"
        ),
      };
    case "ATTENDANCE_RECORDING_FROM_DATE": {
      const value = _.get(selectedConfiguration, id);
      return {
        label: value ? _.capitalize(value) : academicYearStartDate,
      };
    }
    case "ATTENDANCE_OVERALL_PRESENCE_DECIMAL_NUMBER":
      return {
        label: getAttendanceCalculationLabel({
          t,
          attendanceDecimal: _.get(selectedConfiguration, id, "2"),
          attendanceCalculation: _.get(
            selectedConfiguration,
            "ATTENDANCE_OVERALL_PRESENCE_SCORE_CALCULATION",
            "ROUND"
          ),
        }),
      };
    case "OVERALL_ATTENDANCE_PERCENTAGE_TYPE":
      return {
        label: _.startCase(_.toLower(_.get(selectedConfiguration, id))),
      };
    default:
      return {
        label: _.get(selectedConfiguration, id),
      };
  }
};

export const getSegmentedProgressByStep = ({ step }) => {
  const step1Color = _.includes(["STEP_1", "STEP_2"], step)
    ? colors.surfaceDark
    : colors.neutral600;
  const step2Color = _.includes(["STEP_2"], step)
    ? colors.surfaceDark
    : colors.neutral600;

  return [
    {
      id: "STEP_1",
      color: step1Color,
      progress: 49.5,
    },
    {
      id: "GAP_1",
      color: "#ffffff",
      progress: 1,
    },
    {
      id: "STEP_2",
      color: step2Color,
      progress: 49.5,
    },
  ];
};

export const getAttendanceBulkApplyMutationVariables = ({
  selectedConfiguration,
  configurations,
  isUpdateBulkApply,
  selectedSchool,
  globalConstantMap,
}) => {
  const configurationsMap = _.keyBy(
    _.get(configurations, "0.configurations"),
    "configuration"
  );

  const defaultPeriod = _.find(
    _.get(selectedSchool, "periodSet.periods", []),
    ({ isDefault }) => isDefault
  );

  const schoolGlobalConstants = _.get(
    globalConstantMap,
    _.get(selectedSchool, "id")
  );

  const markingSettingsMap = {
    ATTENDANCE_RECORDING_TYPE: true,
    HOMEROOM_PERIOD: {
      key: "LINK_PERIOD.value",
      transform: value => value,
    },
    HOMEROOM_PERIOD_ATTENDANCE_SYNC_TYPE: true,
    ATTENDANCE_RECORDING_FROM_DATE: true,
    ENABLE_ATTENDANCE_AUTO_MARKING: {
      transform: value => _.toString(value),
    },
    ATTENDANCE_AUTO_MARKING_TIME: true,
    OVERALL_ATTENDANCE_PERCENTAGE_TYPE: true,
    ATTENDANCE_OVERALL_PRESENCE_DECIMAL_NUMBER: true,
    ATTENDANCE_OVERALL_PRESENCE_SCORE_CALCULATION: true,
    DAILY_ATTENDANCE_RECORDING_TYPE: {
      key: "DAILY_ATTENDANCE_RECORDED_IN",
    },
  };

  const markingSettings = _.chain(markingSettingsMap)
    .entries()
    .reduce((acc, [name, config]) => {
      const key = _.isObject(config) && config.key ? config.key : name;

      const isHomeroomPeriod = name === "HOMEROOM_PERIOD";

      const value = isHomeroomPeriod
        ? _.get(selectedConfiguration, key, "")
        : _.get(selectedConfiguration, key);

      const existingValue = _.get(schoolGlobalConstants, name);

      const isValueChanged = isHomeroomPeriod
        ? _.get(defaultPeriod, "id") !== value &&
          _.get(defaultPeriod, "parent.id") !== value
        : existingValue !== value;

      if (
        !_.isNil(value) &&
        !(isHomeroomPeriod && _.isEmpty(value)) &&
        isValueChanged
      ) {
        const transformedValue =
          _.isObject(config) && config.transform
            ? config.transform(value)
            : JSON.stringify(value);

        acc.push({ name, value: transformedValue });
      }
      return acc;
    }, [])
    .value();

  const configurationsList = _.reduce(
    [
      "AllowToUpdateAttendanceCodeValue",
      "AllowToUpdateAttendanceCodeNotificationSettings",
      "AllowToCreateAttendanceCode",
      "AllowToUpdateAttendanceTier",
    ],
    (acc, key) => {
      const id = _.get(configurationsMap[`Common:${key}`], "id");
      const value = _.get(selectedConfiguration, key, false);

      acc.push({ id, value });
      return acc;
    },
    []
  );

  const getUpdatedAttendanceOptions = () => {
    const existingAttendanceOptionsMap = _.keyBy(
      _.get(selectedSchool, "attendanceOptionSet.attendanceOptions"),
      "id"
    );

    const attendanceOptions = _.map(
      selectedConfiguration.ATTENDANCE_CODES,
      code => ({
        attendanceOptionId: _.get(code, "id"),
        value: _.toNumber(_.get(code, "value")),
        sendSMS: _.get(code, "sendSMS"),
        sendEmail: _.get(code, "sendEmail"),
      })
    );

    const updatedAttendanceOptions = _.reduce(
      attendanceOptions,
      (acc, option) => {
        const existingAttendanceOption =
          existingAttendanceOptionsMap[_.get(option, "attendanceOptionId")];

        if (
          _.isNil(existingAttendanceOption) ||
          !_.isEqual(
            _.pick(existingAttendanceOption, ["value", "sendSMS", "sendEmail"]),
            _.pick(option, ["value", "sendSMS", "sendEmail"])
          )
        ) {
          acc.push(option);
        }
        return acc;
      },
      []
    );

    return isUpdateBulkApply ? updatedAttendanceOptions : attendanceOptions;
  };

  const attendanceTierSetId = _.get(
    selectedConfiguration,
    "ATTENDANCE_TIERS.id",
    null
  );

  const attendanceOptions = getUpdatedAttendanceOptions();

  return {
    input: {
      schoolIds: isUpdateBulkApply
        ? [_.get(selectedSchool, "id")]
        : _.map(selectedConfiguration.SCHOOLS, ({ id }) => id),
      configurations: configurationsList,
      ...(!_.isEmpty(markingSettings) && { markingSettings }),
      ...(!_.isEmpty(attendanceOptions) && { attendanceOptions }),
      ...(!_.isNil(attendanceTierSetId) && {
        attendanceTierSet: {
          attendanceTierSetId,
        },
      }),
    },
  };
};

export const createAttendanceTierColumnList = [
  {
    id: "PERCENTAGE_RANGE",
    label: "Attendance Range",
    type: "CUSTOM",
  },
  {
    id: "TIER",
    label: "Tier",
    type: "CUSTOM",
  },
  {
    id: "COLOR",
    label: "Color",
    type: "CUSTOM",
    alignment: "center",
    style: {
      width: "68px",
    },
  },
  {
    id: "ACTIONS",
    label: "",
    type: "ACTIONS",
    alignment: "center",
    style: {
      width: "104px",
    },
  },
];

export const attendanceTierscolorPalette = [
  { color: "var(--tag-background-green-default)", label: "Green" },
  { color: "var(--tag-background-yellow-default)", label: "Yellow" },
  { color: "var(--tag-background-pink-default)", label: "Pink" },
  { color: "var(--tag-background-purple-default)", label: "Purple" },
  { color: "var(--tag-background-teal-default)", label: "Teal" },
  { color: "var(--tag-background-violet-default)", label: "Violet" },
  { color: "var(--tag-background-neutral-default)", label: "Neutral" },
  { color: "var(--tag-background-orange-default)", label: "Orange" },
];

export const getInitialTierSetData = () => [
  {
    PERCENTAGE_RANGE: {
      index: 0,
      minPercentage: 90,
      label: "",
      isDefault: false,
    },
    TIER: {
      label: "Good",
      index: 0,
    },
    COLOR: {
      color: "var(--tag-background-teal-default)",
      label: "",
      index: 0,
    },
    id: null,
    isDefault: false,
  },
  {
    PERCENTAGE_RANGE: {
      index: 1,
      minPercentage: 0,
      label: "",
      isDefault: false,
    },
    TIER: {
      label: "At risk",
      index: 1,
    },
    COLOR: {
      color: "var(--tag-background-pink-default)",
      label: "",
      index: 1,
    },
    id: null,
    isDefault: true,
  },
];

export const checkIsAttendanceCodeEnhancementEnabled = () => {
  return ACLStore.can("FeatureFlag:AttendanceCodeEnhancement");
};

export const getAttendanceOptionRnpRolesEnabled = () => {
  return ACLStore.can("FeatureFlag:AttendanceOptionRnpRoles");
};

export const getCanManageAttendanceOptionRnpRolesEnabled = () => {
  return ACLStore.can("FeatureFlag:CanManageAttendanceOptionRnpRoles");
};

export const getIsStudentTimetableClassRedirectionEnabled = () => {
  return ACLStore.can("FeatureFlag:StudentTimetableClassRedirection");
};

export const getIsAttendanceCodesSortingEnabled = () => {
  return ACLStore.can("FeatureFlag:EnableAttendanceCodesSorting");
};

export const getDefaultOverallAttendancePercentageType = selectedRecordingType => {
  switch (selectedRecordingType) {
    case ATTENDANCE_CONSTANTS.EACH_PERIOD:
    case ATTENDANCE_CONSTANTS.EACH_PERIOD_WITH_ONCE_A_DAY:
      return "PERIOD";
    case ATTENDANCE_CONSTANTS.ONCE_A_DAY:
      return "DAILY";
  }
};

export const getConfigurationBooleanValue = item => {
  const emailChannelValue = _.get(item, "channelTypeCategorizedValues.email");

  const configurationValue =
    emailChannelValue !== "true" ? _.get(item, "value") : emailChannelValue;
  return configurationValue === "true";
};
